package app.spliddy.web

import app.spliddy.web.strings.ResStrings

internal object Res {
  public val string: ResStrings = ResStrings
}
